export default __webpack_public_path__ + "static/media/catBasket.42a2be96.svg";